/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_ae3ff5f7{list-style:none;margin:0;padding:0}\n"}]);
export const root = "root_ae3ff5f7";